import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, lastValueFrom, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { ErrorToastService } from './error-toast.service';

@Injectable({
  providedIn: 'root',
})
export class HttpHelperService {
  constructor(private http: HttpClient, private errorToast: ErrorToastService) {}

  request(method: string, url: string, body?: any, params?: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options: { params?: any; headers?: HttpHeaders } = { headers };
    if (params) {
      options.params = params;
    }

    return this.http
      .request(method, url, { body, ...options })
      .pipe(catchError(error => this.handleError(error)));
  }

  async requestPromise(
    method: string,
    url: string,
    body?: any,
    params?: any,
    cancelSignal?: Subject<void>
  ): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options: { params?: any; headers?: HttpHeaders } = { headers };
    if (params) {
      options.params = params;
    }

    let observable$ = this.http
      .request(method, url, { body, ...options })
      .pipe(catchError(error => this.handleError(error)));

    if (cancelSignal) {
      observable$ = observable$.pipe(takeUntil(cancelSignal));
    }

    try {
      return await lastValueFrom(observable$);
    } catch (error) {
      throw error;
    }
  }

  private handleError(error: HttpErrorResponse) {
    const title = 'Please try again or contact support if the issue continues. We apologize for any inconvenience';
    this.errorToast.showErrorWithDetails(title, error.message);
    return throwError(() => error);
  }
}
